module.exports = __webpack_public_path__ + "dockerfile.svg";